import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e646c48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-wrapper start" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "data-wrapper mid" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Online", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Offline", -1))
const _hoisted_8 = { class: "data-wrapper end" }
const _hoisted_9 = {
  key: 0,
  class: "arrows"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.artwork?.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle(_ctx.role !== 'private_seller' ? 'cursor: grab' : ''),
          class: "container"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: 
          _ctx.artwork.image &&
          (_ctx.artwork.image.medium !== null || _ctx.artwork.image.original !== null)
            ? _ctx.artwork.image.medium || _ctx.artwork.image.original
            : require('@/assets/imgs/avatar.png')
        ,
              alt: _ctx.artwork?.title
            }, null, 8, _hoisted_2),
            _createElementVNode("div", null, [
              _createElementVNode("p", null, _toDisplayString(_ctx.artwork.artist.full_name), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.artwork.title), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.artwork.active)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-circle-medium",
                    style: {"color":"green","padding":"1rem"}
                  }),
                  _hoisted_5
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-circle-medium",
                    style: {"color":"red","padding":"1rem"}
                  }),
                  _hoisted_7
                ]))
          ]),
          _createElementVNode("div", _hoisted_8, [
            ((_ctx.role === 'gallery' || _ctx.role === 'private_seller') && _ctx.draggable)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  icon: "mdi-content-copy",
                  style: {"color":"white","background-color":"black","padding":"1.3rem","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = () => _ctx.duplicateArtwork(_ctx.artwork))
                }))
              : _createCommentVNode("", true),
            (_ctx.draggable)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  icon: "mdi-pencil",
                  style: {"color":"white","background-color":"black","padding":"1.3rem","cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = () => _ctx.$router.push(`/artworks/${_ctx.artwork.id}`))
                }))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: "link",
                  to: `/artworks/${_ctx.artwork.id}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Edit Artwork ")
                  ]),
                  _: 1
                }, 8, ["to"])),
            (_ctx.draggable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayArtworkImages(_ctx.artwork.id))),
                  type: "button"
                }, " Add Images "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.draggable && _ctx.role !== 'private_seller')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-arrow-up-bold",
                  onClick: _ctx.moveUp
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_icon, {
                  icon: "mdi-arrow-down-bold",
                  onClick: _ctx.moveDown
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_v_divider)
  ], 64))
}